import * as React from 'react';
import MomentUtils from '@date-io/moment';
import moment from 'moment';
import { MuiPickersUtilsProvider, KeyboardDatePicker } from '@material-ui/pickers/';
import strings from "./../../utils/StringManager";
import { DateType } from '@date-io/type';
import './QdDatePickers.css';

export interface Props {
	value: DateType,
	onChange?: (date: moment.Moment) => void,
	error?: string,
	label?: string,
	className?: string,
}

export default class QdDatePickerControl extends React.Component<Props, {}> {
	
	handleOnChange(dateTime: moment.Moment, value?: string) {

		if (this.props.onChange) {
			if (!dateTime) {
				this.props.onChange(null);
				return;
			}
			this.props.onChange(moment({
				year: dateTime.year(),
				month: dateTime.month(),
				day: dateTime.date()
			}));
		}
	}

	render() {
		let className = "input-picker " + this.props.className;
		if (this.props.error) {
			className += " input-validation-error";
		};

		return <div className="qd-control-datetime-picker">
			<MuiPickersUtilsProvider utils={MomentUtils}>
				<KeyboardDatePicker
					variant="inline"
					inputVariant="outlined"
					className="input-picker-root"
					autoOk
					value={this.props.value}
					onChange={this.handleOnChange.bind(this)}
					animateYearScrolling
					format={(window as any).qdesk.settings.dateFormat}
					invalidDateMessage={strings.get("invalidDateMessage")}
					label={this.props.label}
					InputProps={{
						className: className
					}}
					onError={function () { console.log("DatePicker Error:", arguments) }}
				/>
			</MuiPickersUtilsProvider>
		</div>
	}
}